import React from "react";
import { Route, Switch } from "react-router-dom";
import { getPath } from "common/routing";
import { Layout } from "../Common/FullWidthLayout";
import { TasksTable } from "./TasksTable";

export default () => (
  <Layout title="Tasks">
    <Switch>
      <Route path={getPath("tasksTable")} component={TasksTable} />
    </Switch>
  </Layout>
);
